import { SET_TOKEN, ACCESS_TOKEN } from '../mutation-types'
import store from 'store'
import { login } from '@/api/user'
import jwt_decode from "jwt-decode"
// import { ActionTree, Getter, GetterTree, Module, MutationTree } from 'vuex'


const state = {
    userinfo: {},
    token: ''
}

const actions = {
    login({ commit }, params) {
        return new Promise((resolve, reject) => {
            login(params).then(resp => {
                if (resp?.code == 0) {
                    const token = resp?.data?.Token
                    commit(SET_TOKEN, token)
                    store.set(ACCESS_TOKEN, token) // 存储到 localStorage
                    resolve()
                } else {
                    reject(resp?.message)
                }

            }).catch(err => {
                reject(err)
            })
        })
    }
}

const mutations = {
    [SET_TOKEN]: (state, token) => {
        if (!!token) {
            state.token = token
            state.userinfo = jwt_decode(token)
        }
    },
}

const getters = {
    token: state => state.token,
    userinfo: state => state.userinfo,
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}